import { UserInfoListDto } from "../../services";
import { PermissionManager } from "./PermissionManager";

type props = {
  user: UserInfoListDto | null;
  children: JSX.Element;
};

export function RequireManagePermission({ user, children }: props) {
  return <>{PermissionManager.canManage(user) ? children : <></>}</>;
}
